export default __webpack_public_path__ + "static/media/image52.1aae73b6.png";